import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined'
import CloudOutlinedIcon from '@mui/icons-material/CloudOutlined'
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined'
import HubOutlinedIcon from '@mui/icons-material/HubOutlined'
import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined'
import { SectionDefinition } from '../../../components/Sections/Sections.types'

export enum TrailSystemSectionIds {
  general = 'general',
  location = 'location',
  weather = 'weather',
  tuningProfiles = 'tuningProfiles',
  stewards = 'stewards',
  integrations = 'integrations',
}

/**
 * @description Sections shared by the Trail System detail page and edit form, in display order.
 */
export const trailSystemSections: SectionDefinition[] = [
  {
    id: TrailSystemSectionIds.general,
    title: 'General',
    description: 'Name, app link, and visibility.',
    icon: InfoOutlinedIcon,
  },
  {
    id: TrailSystemSectionIds.location,
    title: 'Location',
    description: 'Address and parking lots. Trails can link to these parking lots.',
    icon: PlaceOutlinedIcon,
  },
  {
    id: TrailSystemSectionIds.weather,
    title: 'Weather & Algorithm',
    description: 'Weather sources and the defaults the status algorithm uses for every trail in this system.',
    icon: CloudOutlinedIcon,
  },
  {
    // detail page only: profiles are managed in place, not through the edit form
    id: TrailSystemSectionIds.tuningProfiles,
    title: 'Tuning Profiles',
    description: 'Saved sets of tuning values, e.g. Summer and Winter, to switch between when the weather turns.',
    icon: TuneOutlinedIcon,
  },
  {
    id: TrailSystemSectionIds.stewards,
    title: 'Trail Stewards',
    description: 'Organizations responsible for maintaining this trail system.',
    icon: GroupsOutlinedIcon,
  },
  {
    id: TrailSystemSectionIds.integrations,
    title: 'Integrations',
    description: 'Sync trail statuses to third-party services.',
    icon: HubOutlinedIcon,
  },
]
